import { useState, useEffect } from "react";
import Constantes from "../../constantes";

function VistaAdmin() {
    const [incidenciasPendientes, setIncidenciasPendientes] = useState([]);
    const [incidenciasGrupoPendientes, setIncidenciasGrupoPendientes] = useState([]);
    const [todasLasIncidencias, setTodasLasIncidencias] = useState([]);
    const [todasLasIncidenciasGrupo, setTodasLasIncidenciasGrupo] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);

    useEffect(() => {
        const fetchIncidenciasGrupoPendientes = async () => {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/incidencias/getPendingGroupIncidencias', {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await respuesta.json();
                setIncidenciasGrupoPendientes(data.message || []);
            } catch (error) {
                console.error('Error al obtener las incidencias de grupo pendientes:', error);
            }
        };

        const fetchTodasLasIncidenciasGrupo = async () => {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/incidencias/getAllGroupIncidencias', {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await respuesta.json();
                setTodasLasIncidenciasGrupo(data.message || []);
            } catch (error) {
                console.error('Error al obtener todas las incidencias de grupo:', error);
            }
        };

        const fetchIncidenciasPendientes = async () => {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/incidencias/getPendingIncidencias', {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await respuesta.json();
                console.log("Incidencias pendientes de grupo:", data.message);
                setIncidenciasPendientes(data.message || []);
            } catch (error) {
                console.error('Error al obtener las incidencias pendientes:', error);
            }
        };

        const fetchTodasLasIncidencias = async () => {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/incidencias/getAllIncidencias', {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await respuesta.json();

                console.log("Todas las incidencias de grupo:", data.message);

                setTodasLasIncidencias(data.message || []);
            } catch (error) {
                console.error('Error al obtener todas las incidencias:', error);
            }
        };

        fetchTodasLasIncidencias();
        fetchIncidenciasPendientes();
        fetchTodasLasIncidenciasGrupo();
        fetchIncidenciasGrupoPendientes();
    }, []);

    const toggleRow = (id) => {
        setExpandedRows(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    };

    function handleGestionar(incidenciaId) {
        window.location.href = `/gestionar_incidencia/${incidenciaId}`;
    }

    return (
        <div className="App d-flex justify-content-center bg-dark text-white min-vh-100 p-4">
            <h1 className="text-center mb-5">Panel de Administración</h1>
            <div>
                <div className="row">
                    <div className="col-md-3 mb-4">
                        <h3 className="text-center mb-3">Incidencias Pendientes</h3>

                        {incidenciasPendientes.length === 0 ? (
                            <p className="text-center">No hay incidencias pendientes.</p>
                        ) : (
                            <ul className="list-unstyled">
                                {incidenciasPendientes.map((incidencia) => {
                                    const expanded = expandedRows.includes(incidencia.id);
                                    return (
                                        <li key={incidencia.id} className="mb-3 p-3 border rounded shadow-sm">
                                            <div
                                                role="button"
                                                onClick={() => toggleRow(incidencia.id)}
                                                className="d-flex justify-content-between align-items-center"
                                            >
                                                <strong>ID: U-{incidencia.id}</strong>
                                                <span>{expanded ? "▲" : "▼"}</span>
                                            </div>

                                            {expanded && (
                                                <div className="mt-2">
                                                    <p><strong>Descripción:</strong> {incidencia.descripcion}</p>
                                                    <p><strong>Fecha:</strong> {new Date(incidencia.fecha_incidencia).toLocaleString()}</p>
                                                    <button className="btn btn-success me-2" onClick={() => handleGestionar(incidencia.id)}>Gestionar</button>
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                    <div className="col-md-3 mb-4">
                        <h3 className="text-center mb-3">Historial de Incidencias</h3>

                        {todasLasIncidencias.length === 0 ? (
                            <p className="text-center">No hay incidencias registradas.</p>
                        ) : (
                            <ul className="list-unstyled">
                                {todasLasIncidencias.map((incidencia) => {
                                    const uid = `all-${incidencia.id}`;
                                    const expanded = expandedRows.includes(uid);

                                    return (
                                        <li key={uid} className="mb-3 p-3 border rounded shadow-sm">
                                            <div
                                                role="button"
                                                onClick={() => toggleRow(uid)}
                                                className="d-flex justify-content-between align-items-center"
                                            >
                                                <strong>ID: U-{incidencia.id}</strong>
                                                <span>{expanded ? "▲" : "▼"}</span>
                                            </div>

                                            {expanded && (
                                                <div className="mt-2">
                                                    <p><strong>Descripción:</strong> {incidencia.descripcion}</p>
                                                    <p><strong>Fecha:</strong> {new Date(incidencia.fecha_incidencia).toLocaleString()}</p>
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                    <div className="col-md-3 mb-4">
                        <h3 className="text-center mb-3">Incidencias de Grupos Pendientes</h3>
                        {incidenciasGrupoPendientes.length === 0 ? (
                            <p className="text-center">No hay incidencias de grupos pendientes.</p>
                        ) : (
                            <ul className="list-unstyled">
                                {incidenciasGrupoPendientes.map((incidencia) => {
                                    const uid = `group-${incidencia.id}`;
                                    const expanded = expandedRows.includes(uid);
                                    return (
                                        <li key={uid} className="mb-3 p-3 border rounded shadow-sm">
                                            <div
                                                role="button"
                                                onClick={() => toggleRow(uid)}
                                                className="d-flex justify-content-between align-items-center"
                                            >
                                                <strong>ID: G-{incidencia.id}</strong>
                                                <span>{expanded ? "▲" : "▼"}</span>
                                            </div>
                                            
                                            {expanded && (
                                                <div className="mt-2">
                                                    <p><strong>Descripción:</strong> {incidencia.descripcion}</p>
                                                    <p><strong>Fecha:</strong> {new Date(incidencia.fecha_incidencia).toLocaleString()}</p>
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                    <div className="col-md-3 mb-4">
                        <h3 className="text-center mb-3">Historial de Incidencias de Grupos</h3>
                        {todasLasIncidenciasGrupo.length === 0 ? (
                            <p className="text-center">No hay incidencias de grupos registradas.</p>
                        ) : (
                            <ul className="list-unstyled">
                                {todasLasIncidenciasGrupo.map((incidencia) => {
                                    const uid = `all-group-${incidencia.id}`;
                                    const expanded = expandedRows.includes(uid);
                                    return (
                                        <li key={uid} className="mb-3 p-3 border rounded shadow-sm">
                                            <div
                                                role="button"
                                                onClick={() => toggleRow(uid)}
                                                className="d-flex justify-content-between align-items-center"
                                            >
                                                <strong>ID: G-{incidencia.id}</strong>
                                                <span>{expanded ? "▲" : "▼"}</span>
                                            </div>
                                            {expanded && (
                                                <div className="mt-2">
                                                    <p><strong>Descripción:</strong> {incidencia.descripcion}</p>
                                                    <p><strong>Fecha:</strong> {new Date(incidencia.fecha_incidencia).toLocaleString()}</p>
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default VistaAdmin;
